var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV2RevampedPlaystore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0731 15.2822L0.119476 29.3412C0.120693 29.3437 0.120693 29.3475 0.121909 29.3499C0.519752 30.8765 1.8824 32 3.50053 32C4.14779 32 4.7549 31.8208 5.27562 31.5073L5.31699 31.4824L19.8973 22.8791L13.0731 15.2822Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1775 12.8886L26.1653 12.8799L19.8704 9.14864L12.7786 15.6021L19.8959 22.8779L26.1568 19.184C27.2542 18.5769 28 17.3937 28 16.0301C28 14.6739 27.2652 13.497 26.1775 12.8886Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.119231 2.65734C0.0413659 2.95096 0 3.25951 0 3.57802V28.4214C0 28.7399 0.0413659 29.0484 0.120448 29.3408L13.5181 15.6414L0.119231 2.65734Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1688 16L19.8725 9.14593L5.30923 0.511464C4.77999 0.186739 4.16193 0.000116348 3.50129 0.000116348C1.88315 0.000116348 0.518077 1.12608 0.120235 2.65391C0.120235 2.65515 0.119019 2.65639 0.119019 2.65764L13.1688 16Z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2RevampedPlaystore);
export default __webpack_public_path__ + "static/media/v2_revamped_playstore.b49f5bc713f8d41f9f2c87da32ef9782.svg";
export { ForwardRef as ReactComponent };